import { LoadingButton } from "@mui/lab";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

interface ConfirmDialogProps {
  title: string;
  children: React.ReactNode;
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmDialog = ({
  title,
  children,
  open,
  onClose,
  onConfirm,
  loading = false,
}: ConfirmDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-dialog"
      fullWidth
    >
      <DialogTitle id="confirm-dialog">{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button variant="text" onClick={onClose} sx={{ color: "text.primary" }}>
          No
        </Button>
        <LoadingButton
          loading={loading}
          variant="contained"
          onClick={() => {
            onConfirm();
          }}
        >
          Yes
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default ConfirmDialog;
